import CraftTypeSelectField from "./craft-type-select-field";
import CraftStatusSelectField from "./craft-status-select-field";


const CraftFields = {
    TypeSelect   : CraftTypeSelectField,
    StatusSelect : CraftStatusSelectField
};

export default CraftFields;